import {AuthTrackingState, initialAuthTrackingState} from './auth-tracking/auth-tracking.state';
import {AuthState, initialAuthState} from './auth/auth.state';
import {BatchInspectorState, initialBatchInspectorState} from './batch-inspector/batch-inspector.state';
import {BatchTrackingState, initialBatchTrackingState} from './batch-tracking/batch-tracking.state';
import {CarrierState, initialCarrierState} from './carrier/carrier.state';
import {ClearanceInspectorState, initialClearanceInspectorState} from './clearance-inspector/clearance-inspector.state';
import {ClientDashboardState, initialClientDashboardState} from './client-dashboard/client-dashboard.state';
import {initialManifestrState, ManifestrState} from './manifestr/manifestr.state';
import {EventRecordrState, initialEventRecordrState} from './event-recordr/event-recordr.state';
import {FacilityState, initialFacilityState} from './facility/facility.state';
import {GatewayState, initialGatewayState} from './gateway/gateway.state';
import {ParsState, initialParsState} from './pars/pars.state';
import {PieceInspectorState, initialPieceInspectorState} from './piece-inspector/piece-inspector.state';
import {CustomRouterReducerState} from './router/router.state';
import {WorkspaceState, initialWorkspaceState} from './workspace/workspace.state';

export interface AppState {
  auth: AuthState;
  batchTracking: BatchTrackingState;
  carriers: CarrierState;
  facilities: FacilityState;
  pars: ParsState;
  router: CustomRouterReducerState;
  workspace: WorkspaceState;
  gateway: GatewayState;
  batchInspector: BatchInspectorState;
  pieceInspector: PieceInspectorState;
  clearanceInspector: ClearanceInspectorState;
  clientDashboard: ClientDashboardState;
  authTracking: AuthTrackingState;
  manifestr: ManifestrState;
  eventRecordr: EventRecordrState;
}

export const initialAppState: AppState = {
  auth: initialAuthState,
  batchTracking: initialBatchTrackingState,
  carriers: initialCarrierState,
  facilities: initialFacilityState,
  pars: initialParsState,
  router: null,
  workspace: initialWorkspaceState,
  gateway: initialGatewayState,
  batchInspector: initialBatchInspectorState,
  pieceInspector: initialPieceInspectorState,
  clearanceInspector: initialClearanceInspectorState,
  clientDashboard: initialClientDashboardState,
  authTracking: initialAuthTrackingState,
  manifestr: initialManifestrState,
  eventRecordr: initialEventRecordrState,
};
